<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='10vh' @close='dialogClose' width='1050px' append-to-body class='dialogForm'>
    <el-tabs v-model='activeName' @tab-click='handleClick' class='formHeight'>
      <el-tab-pane label='基础信息' name='basicInformation'>
        <basic-information :form='form' />
      </el-tab-pane>
      <el-tab-pane label='结算费用' name='settlementFee'>
        <my-table ref='settlementFee' :tableOption='settlementFeeOption' />
      </el-tab-pane>
      <el-tab-pane label='开票信息' name='billingInformation'>
        <my-table ref='billingInformation' :table-option='billingInformationOption' />
      </el-tab-pane>
      <el-tab-pane label='其他结算费用' name='otherSettlementFee'>
        <my-table ref='otherSettlementFee' :table-option='otherSettlementFeeOption' />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { receiptDetails, receiptFormSearch } from '@/service/receipt';
  import BasicInformation from './basicInformation';
  import MyTable from './table';

  export default {
    name: 'vehicleSettlementInfo',
    components: {
      BasicInformation,
      MyTable,
      divBorder,
    },
    data() {
      return {
        activeName: 'basicInformation',
        dialogTitle: '详情',
        dialogVisible: false,
        form: {},
        defaultSettlementFeeOption: [
          {
            prop: 'batchNumber',
            label: '批次号',
          },
          {
            prop: 'waybillNo',
            label: '运单号',
          },
          {
            prop: 'frameNumber',
            label: '车架号',
          },
          {
            prop: 'brandName',
            label: '品牌',
          },
          {
            prop: 'modelName',
            label: '型号',
          },
          {
            prop: 'standingBookMonth',
            label: '台账月',
          },
        ],
        contract: [
          {
            prop: 'taxContractPrice',
            label: '含税合同价',
          },
          {
            prop: 'contractPrice',
            label: '不含税合同价',
          },
        ],
        preSettlement: [
          {
            prop: 'taxPreparePrice',
            label: '含税预结算价',
          },
          {
            prop: 'preparePrice',
            label: '不含税预结算价',
          },
        ],
        settlementFeeOption: [],
        billingInformationOption: [
          {
            prop: 'invoiceNo',
            label: '发票号码',
          },
          {
            prop: 'invoiceCode',
            label: '发票代码',
          },
          {
            prop: 'invoicDate',
            label: '发票日期',
          },
          {
            prop: 'taxPrice',
            label: '含税金额',
          },
          {
            prop: 'price',
            label: '不含税金额',
          },
          {
            prop: 'taxRate',
            label: '税率',
          },
          {
            prop: 'invoiceType',
            label: '开票类型',
            formatter: (r, c, cellValue) => {
              switch (cellValue) {
                case 0:
                  return '正常开票';
                case 1:
                  return '补开票';
              }
            },
          },
          {
            prop: 'printStatus',
            label: '打印状态',
            formatter: (r, c, cellValue) => {
              switch (cellValue) {
                case 0:
                  return '未打印';
                case 1:
                  return '已打印';
              }
            },
          },
        ],
        otherSettlementFeeOption: [
          {
            prop: 'costNum',
            label: '费用编号',
          },
          {
            prop: 'costTypeName',
            label: '费用类型',
          },
          {
            prop: 'costInstruction',
            label: '费用说明',
          },
          {
            prop: 'costTime',
            label: '费用时间',
          },
          {
            prop: 'taxRate',
            label: '税率（%）',
          },
          {
            prop: 'costAmount',
            label: '含税价',
          },
          {
            prop: 'excludingTaxAmount ',
            label: '不含税价',
          },
        ],
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
    },
    methods: {
      handleClick(tab, event) {
        switch (tab.name) {
          case 'settlementFee':
            this.$refs.settlementFee.setSearchApi(1, this.form);
            break;
          case 'billingInformation':
            this.$refs.billingInformation.setSearchApi(2, this.form);
            break;
          case 'otherSettlementFee':
            this.$refs.otherSettlementFee.setSearchApi(3, this.form);
            break;
        }
      },
      dialogOpen(row) {
        this.form = JSON.parse(JSON.stringify(row));
        const arr = row.settType === 1 ? this.contract : this.preSettlement;
        this.settlementFeeOption = [...this.defaultSettlementFeeOption, ...arr];
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
